'use client';
import { useState } from 'react';
import { useResetPassword } from '@/utils/react-query-hooks';
import { Email } from '@/components/presentational/tailwind/Auth/Email';

export function ForgotPassword() {
  const [successMessage, setSuccessMessage] = useState<string | undefined>(undefined);
  const magicLinkMutation = useResetPassword({
    onSuccess: () => {
      setSuccessMessage('A magic link has been sent to your email!');
    },
  });

  return (
    <div className="container grid items-center h-full max-w-lg mx-auto overflow-auto overflow-visible">
      <div className="space-y-8 ">
        <div className="space-y-2 ">
          <h1 className="mt-10 mb-3 text-2xl font-semibold text-center text-slate-900 sm:text-3xl lg:mt-5 xl:mt-7 xl:text-2xl">Reset password</h1>
          <p className="max-w-sm mx-auto text-sm leading-6 text-center text-gray-500">
            Enter your email to receive a magic link to reset your password.
          </p>
        </div>

        <Email
          successMessage={successMessage}
          isLoading={magicLinkMutation.isLoading}
          view="forgot-password"
          onSubmit={(email) => {
            magicLinkMutation.mutate({
              email,
            });
          }}
        />
      </div>
    </div>
  );
}
